var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bce-student-wrapper"},[_c('v-container',{staticClass:"px-md-8 py-md-6 pa-4 bce-content-container",staticStyle:{"min-height":"calc(100vh - 64px)"},attrs:{"fluid":""}},[_c('div',{staticClass:"w-100 bce-module-wrapper"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }